export enum CHAPTER_FINISHED_DIALOG_RESULT {
  RETURN_TO_DASHBOARD = 0,
  CONTINUE = 1,
}
